import { weave } from '../../../components/utils/arrayUtils'

const masonryImagesLandscape = [
  {
    medium:
      'https://assets.riparide.com/home/host_info/1/medium-490ae7d23d86aa283728bd6e6052c781.jpg',
    large:
      'https://assets.riparide.com/home/host_info/1/large-d624628e8caa640aab18359db667660c.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/home/host_info/4/medium-3839c14956b0c58aa1f9c748aaecaf6f.jpg',
    large:
      'https://assets.riparide.com/home/host_info/4/large-96deaa755e6c0ad2c5a8c95a8d5bfa74.jpg',
  },
]

const masonryImagesPortrait = [
  {
    medium:
      'https://assets.riparide.com/home/host_info/3/medium_03-11-2021_1133.jpg',
    large:
      'https://assets.riparide.com/home/host_info/3/large-451c71e11f421e007093413c6bace491.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/home/host_info/2/medium-cf06bdecf3640eee7dd172b14f3c7fa3.jpg',
    large:
      'https://assets.riparide.com/home/host_info/2/large-b3a9a3b1ab52f57dc9aba24eb77c7d0e.jpg',
  },
]

export const masonryImages = weave(
  masonryImagesPortrait,
  masonryImagesLandscape
)

export const avatarUrls = [
  'https://assets.riparide.com/landing_pages/list-with-us/testimonials/fay_bushby.jpg',
  'https://assets.riparide.com/landing_pages/list-with-us/testimonials/lisa_deppeler.jpg',
  'https://assets.riparide.com/landing_pages/list-with-us/testimonials/andy_matenson.jpg',
  'https://assets.riparide.com/landing_pages/list-with-us/testimonials/jacob_stammers.jpg',
]
